import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ReactComponent as Logo } from './../../graphics/images/leagueLogo.svg';
import { useDevTools } from './../../AppContext';

import styles from './SignInSMS.module.css';
import { DevOnlyFormFiller } from '../../DevTools/DevOnlyFormFiller';
import AppSpinner from '../../partials/AppSpinner';
import SignInHeader from '../SignInHeader/SignInHeader';
import PrimaryButton from '../../partials/PrimaryButton';
import { requestOtp, verifyOtp } from '../../api/newAuthApi';
import { getUserPlayerInfo } from '../../api/getUserPlayerInfo';

function SignInSMS(props) {
  let history = useHistory();
  const { user, setUser } = props;
  const devToolsSettings = useDevTools();

  const [stage, setStage] = React.useState('phone');
  const [phone, setPhone] = React.useState('');
  const [smsCode, setSmsCode] = React.useState('');
  const [requestId, setRequestId] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState('');
  const [resendCooldown, setResendCooldown] = React.useState(0);

  // Countdown timer for rate-limit cooldown
  React.useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setInterval(() => {
      setResendCooldown(s => s - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [resendCooldown]);

  const handlePhoneChange = e => {
    setPhone(e.target.value);
    setErrorMsg('');
  };

  const handleSmsCodeChange = e => {
    setSmsCode(e.target.value);
    setErrorMsg('');
  };

  const handleSendMyPhoneNumber = async e => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg('');

    const res = await requestOtp(phone);



    setIsLoading(false);

    if (res.error) {
      if (res.error === 'rate_limit') {
        setResendCooldown(30);
      }
      setErrorMsg(res.message);
      return;
    }

    setRequestId(res.requestId);
    setStage('code');
  };

  const handleVerifyCode = async e => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg('');

    const res = await verifyOtp({ requestId, code: smsCode });

    if (res.error) {
      setIsLoading(false);
      setErrorMsg(res.message);
      return;
    }

    if (res.isNewUser) {
      sessionStorage.setItem('otp_temp_token', res.tempToken);
      history.push(`/quick-signup/1?tel=${encodeURIComponent(res.phoneNumber)}`);
      return;
    }

    // Existing user — token already stored in cookie by verifyOtp
    const userInfo = await getUserPlayerInfo();
    setUser(userInfo);
    setIsLoading(false);
  };

  const handleBackToPhone = () => {
    sessionStorage.removeItem('otp_temp_token');
    setStage('phone');
    setSmsCode('');
    setErrorMsg('');
  };

  React.useEffect(() => {
    if (user !== null && user !== undefined) {
      history.push('/redirect');
    }
  }, [user, history]);

  return (<div className={styles.signIn}>
    <div className={styles.logo}>
      <Logo />

    </div>
    <h1 style={{ position: 'relative' }}>
      {stage === 'phone' ? 'כניסה לליגות' : 'הזנת קוד אימות'}
      <div style={{
        top: '30px',
        position: 'absolute',
        width: '100%',
        height: '40px',
        overflow: 'hidden',
      }}>

        <div style={{
          position: 'relative',
          minHeight: '80px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {isLoading && <AppSpinner size={'small'}
                                    label={stage === 'phone' ? 'שולח...' : 'מאמת...'} />}
        </div>

      </div>

    </h1>


    {stage === 'phone' ? (<DevOnlyFormFiller
      formDataForQuickFill={{ phone: '0501111111' }}
      setFormData={(v) => {setPhone(v.phone);}}>
      <form onSubmit={handleSendMyPhoneNumber}>
        <input
          type="tel"
          placeholder="נייד"
          value={phone}
          onChange={handlePhoneChange}
        />
        <span className={styles.error}>{errorMsg}</span>
        <PrimaryButton
          type="submit"
          size={'large'}
          text={resendCooldown > 0 ? `שלח קוד מחדש (${resendCooldown})` : (isLoading ? 'שולח...' : 'שליחת קוד')}
          disabled={!phone || phone.length < 8 || isLoading || resendCooldown > 0}
        />
      </form>
    </DevOnlyFormFiller>) : (<DevOnlyFormFiller
      formDataForQuickFill={{ smsCode: '' }}
      setFormData={(v) => {setSmsCode(v.smsCode || '');}}>
      <form onSubmit={handleVerifyCode}>
        <SignInHeader phone={phone} >
          קוד אימות נשלח למספר
        </SignInHeader>
        <input
          dir={'ltr'}
          className={styles.customCodeInput}
          type="text"
          maxLength="6"
          placeholder="קוד אימות"
          value={smsCode}
          onChange={handleSmsCodeChange}
        />
        <span className={styles.error}>{errorMsg}</span>

        {devToolsSettings?.devMode && (
          <p dir={'ltr'} className={styles.devModeButtons}>
            קוד OTP יופיע בלוגים של השרת בסביבת פיתוח
          </p>
        )}
        <PrimaryButton
          type="submit"
          size={'large'}
          text={isLoading ? 'מאמת...' : 'כניסה'}
          disabled={isLoading}
        />
        <PrimaryButton
          type="button"
          size={'large'}
          text="עריכת מספר"
          onClick={handleBackToPhone}
          disabled={isLoading}
        />

      </form>
    </DevOnlyFormFiller>)}

    <Link className={styles.links} to={'signin'}>
      כניסה עם ססמה
    </Link>
  </div>);
}


export default SignInSMS;
